<div class="p-4 connect">
  <!-- ----- Step 0 ------ -->

  <div class="d-flex justify-content-between align-items-center">
    <div></div>
    <h4 class="text-center fw-semibold fs-5 m-0 text-white">{{ 'misc.connect_wallet' | translate }}</h4>
    <svg-icon src="./assets/images/svg-icons/close-white.svg" [svgStyle]="{ 'width.px': 14, 'height.px': 14 }" class="cursor-pointer" (click)="modalRef.hide()"></svg-icon>
  </div>

  <div class="mt-4 content">
    <button type="button" class="btn btn-primary rounded-1 py-2 px-3 w-100 d-flex d-md-none justify-content-between align-items-center mb-3" (click)="connectWallet('bw')">
      <span class="d-inline-block">{{ 'misc.best_wallet' | translate }}</span>
      <img src="./assets/images/bestwallet_modal/bw.png" height="32" width="32" alt="" />
    </button>

    <button type="button" class="btn btn-primary rounded-1 py-2 px-3 w-100 d-md-flex d-none justify-content-between align-items-center mb-3" (click)="connectWallet('walletBW')">
      <span class="d-inline-block">{{ 'misc.best_wallet' | translate }}</span>
      <img src="./assets/images/bestwallet_modal/bw.png" height="32" width="32" alt="" />
    </button>

    <button type="button" class="btn btn-primary rounded-1 py-2 px-3 w-100 d-flex justify-content-between align-items-center mb-3" (click)="connectWallet('wallet')">
      <span class="d-inline-block">{{ 'popup.wallet_connect' | translate }}</span>
      <svg-icon src="./assets/images/svg-icons/wallet.svg" [svgStyle]="{ 'width.px': 32, 'height.px': 32 }"></svg-icon>
    </button>

    <button type="button" class="btn btn-primary rounded-1 py-2 px-3 w-100 d-none d-md-flex justify-content-between align-items-center mb-3" (click)="connectWallet('metamask')">
      <span class="d-inline-block">{{ 'popup.metamask_connect' | translate }}</span>
      <svg-icon src="./assets/images/svg-icons/metamask.svg" [svgStyle]="{ 'width.px': 32, 'height.px': 32 }"></svg-icon>
    </button>

    <button type="button" class="btn btn-primary rounded-1 py-2 px-3 w-100 d-flex justify-content-between align-items-center mb-3" (click)="connectWallet('coinbase')">
      <span class="d-inline-block">{{ 'popup.coinbase_connect' | translate }}</span>
      <svg-icon src="./assets/images/svg-icons/coinbase.svg" [svgStyle]="{ 'width.px': 32, 'height.px': 32 }"></svg-icon>
    </button>

    <!---------- i dont have wallet --------------->

    <button type="button" class="btn btn-clear w-100 d-flex justify-content-center align-items-center aniBtn" (click)="openBestWallet()">
      <svg-icon src="/assets/images/svg-icons/ani-wallet.svg" [svgStyle]="{ 'width.px': 20, 'height.px': 19, 'margin-right.px': 5 }"></svg-icon>
      <span class="d-inline-block text-light">{{ 'popup.no_wallet' | translate }}</span>
    </button>
  </div>
</div>
